import { WEB_SCREENS } from "../../constants/screens";
import { TrackingEvents } from "../../../../Utilities/analytics";
import { storyDataArrayProps } from "../../types";
import { WebStoryNavigation } from "../../navigation/types";

interface StoryObjectNavigatorParams {
  currentObjectScreen: string;
  storyDataArray: storyDataArrayProps;
  routeParams: { storyId?: string };
  navigation: WebStoryNavigation;
  setSelectedObject: (_value: string) => void;
  setShowObjectView: (_value: boolean) => void;
  setYetiIntroArr: () => void;
  setIsNavigateToJourney: (_value: boolean) => void;
  handleBlockSubmit: () => void;
  onNavigateToPlanner?: () => void;
  onTrackEvent?: (event: string, props?: Record<string, unknown>) => void;
}

export const StoryObjectNavigator = ({
  currentObjectScreen,
  storyDataArray,
  routeParams,
  navigation,
  setSelectedObject,
  setShowObjectView,
  setIsNavigateToJourney,
  setYetiIntroArr,
  handleBlockSubmit,
  onNavigateToPlanner,
  onTrackEvent,
}: StoryObjectNavigatorParams) => {
  onTrackEvent?.(TrackingEvents.object_story_button_clicked, {
    object_name: currentObjectScreen,
  });

  if (currentObjectScreen === WEB_SCREENS.MyJourneyScreen) {
    handleBlockSubmit();
    setIsNavigateToJourney(true);
    return;
  }

  const params = {
    navigatedFrom: "story",
    storyId: routeParams?.storyId,
    isLastBlock: storyDataArray?.data?.blocks?.length === 1,
  };

  switch (currentObjectScreen) {
    case WEB_SCREENS.TravelPlanScreen:
      onNavigateToPlanner?.();
      break;
    case WEB_SCREENS.MagicBagPack:
      navigation.navigate(WEB_SCREENS.ApplicationNavigatorStack, {
        screen: WEB_SCREENS.MagicBagPack,
        params,
      });
      break;
    case WEB_SCREENS.FunBoxScreen:
      navigation.navigate(WEB_SCREENS.ApplicationNavigatorStack, {
        screen: WEB_SCREENS.FunBoxScreen,
        params,
      });
      break;
    case WEB_SCREENS.MyWall:
      navigation.navigate(WEB_SCREENS.ApplicationNavigatorStack, {
        screen: WEB_SCREENS.MyWall,
        params,
      });
      break;
    default:
      break;
  }

  setSelectedObject("");
  setShowObjectView(false);
  setYetiIntroArr();
  handleBlockSubmit();
};
